import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const fosettingApi = api
  .enhanceEndpoints({ addTagTypes: ['FOSetting'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOSettings: builder.query<(fo_asetting & bt_awasetting)[], void>({
        query: () => `fosetting/`,
        providesTags: ['FOSetting']
      }),
      getFOSettingById: builder.query<fo_asetting & bt_awasetting, string>({
        query: id => `fosetting/byid/${id}`,
        providesTags: ['FOSetting']
      }),
      insertFOSetting: builder.mutation({
        query: fosetting => ({
          url: `fosetting/`,
          method: 'POST',
          body: fosetting
        }),
        invalidatesTags: ['FOSetting']
      }),
      updateFOSetting: builder.mutation({
        query: fosetting => ({
          url: `fosetting/`,
          method: 'PUT',
          body: fosetting
        }),
        invalidatesTags: ['FOSetting']
      }),
      deleteFOSetting: builder.mutation({
        query: fosetting => ({
          url: `fosetting/${fosetting.se_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOSetting']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOSettingsQuery,
  useGetFOSettingByIdQuery,
  useInsertFOSettingMutation,
  useUpdateFOSettingMutation,
  useDeleteFOSettingMutation
} = fosettingApi;

